function c() {
  var _a, _b;
  window.AppstleIncluded = false, window.RS = void 0, window.RSConfig = void 0, window._RSConfig = void 0, (_b = (_a = document.querySelector('script[src*="appstle-subscription.min.js"]')) == null ? void 0 : _a.parentElement) == null ? void 0 : _b.remove();
}
async function d(p) {
  var _a;
  let n = null;
  window.location.pathname.includes("/products") && (n = await (await fetch(window.location.pathname + ".json")).json());
  const i = (_a = p.querySelector('script[src*="appstle-subscription.min.js"]')) == null ? void 0 : _a.parentElement;
  if (!i) return;
  const o = i == null ? void 0 : i.cloneNode(false);
  for (const t of [...(i == null ? void 0 : i.children) || []]) if (t.tagName === "STYLE") o.appendChild(t);
  else if (t.tagName === "SCRIPT") {
    const s = t.getAttribute("src"), e = document.createElement("script");
    t.id && (e.id = t.id), s ? (e.src = s, e.setAttribute("defer", "")) : (e.type = "module", e.textContent = t.textContent), o.appendChild(e);
  }
  n && (window._RSConfig = window._RSConfig || {}, window._RSConfig.product = n.product), document.body.appendChild(o);
}
const a = { destroy: c, initialize: d };
export {
  a
};
